import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvPhoneBlockValueObject} from "../../../data/value-object/env/EnvPhoneBlockValueObject";
import {EnvPhoneBlockSearchOption} from "../../../data/search-option/env/EnvPhoneBlockSearchOption";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvPhoneBlockIO} from "../../../io/EnvIO";
import {EnvPhoneBlockDescription} from "../../../data/description/env/EnvPhoneBlockDescription";
import {EnvPhoneBlockDescriptor} from "../../../data/descriptor/env/EnvPhoneBlockDescriptor";
import ListOption from "../../ListOption";
import {EnvPhoneBlockSearchOptionDescription} from "../../../data/description/env/EnvPhoneBlockSearchOptionDescription";
import {
    applyEnvPhoneBlockSearchOption,
    EnvPhoneBlockSearchOptionField
} from "../../search-option-field/env/EnvPhoneBlockSearchOptionField";
import ListOrder from "../../ListOrder";
import {SearchIndex} from "../../../io/HttpClient";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvPhoneBlockValueObject[]>([])
    const option = useStatePair<EnvPhoneBlockSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvPhoneBlockIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvPhoneBlockDescription}
                descriptor={EnvPhoneBlockDescriptor}
                showPost
                onPostClick={() => document.location = '/env/phoneBlocks/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/phoneBlocks/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvPhoneBlockSearchOptionDescription}
                fields={EnvPhoneBlockSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvPhoneBlockSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvPhoneBlockDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}